import { z } from 'zod';
import { OwnerCornSchema, OwnerStatusSchema } from '../../owner/owner.js';
export const ListOwnersApiSchema = {
    response: z.object({
        owners: z
            .object({
            ownerId: OwnerCornSchema,
            displayName: z.string().min(1),
            status: OwnerStatusSchema,
        })
            .array(),
    }),
};
export const ListOwnersResponseSchema = ListOwnersApiSchema.response;
